// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill'
import VueAnimateNumber from 'vue-animate-number'
import 'animate.css'
import '@/permission'
import BaiduMap from 'vue-baidu-map'
import '@/assets/iconfont/iconfont.css'
import '@/assets/style/common.css'
import pvuv from '@/utils/pvuv'
Vue.prototype.$pvuv = pvuv;
Vue.config.productionTip = false

// if (process.env.NODE_ENV === 'development') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }
// const { mockXHR } = require('../mock')
// mockXHR()
Vue.prototype.$domain = process.env.NODE_ENV === 'testing'?'https://cs-www.hbgyl.com.cn':'https://www.hbgyl.com.cn'

Vue.use(ElementUI)
Vue.use(VueAnimateNumber)
Vue.use(BaiduMap, {
  ak: 'hNWHPLe9KfGXflmZGyFZLsGta3ccQqMG'
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js